'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DropDownMenu = _react2['default'].createClass({
    displayName: 'DropDownMenu',


    propTypes: {
        dropDownMenuLinkData: _react2['default'].PropTypes.array.isRequired,
        className: _react2['default'].PropTypes.string,
        style: _react2['default'].PropTypes.object,
        id: _react2['default'].PropTypes.string
    },

    render: function render() {
        var dropDownMenuLinks = this.props.dropDownMenuLinkData.map(function (dropDownMenuLink, i, linkArray) {
            if (!dropDownMenuLink.hasOwnProperty('options') || dropDownMenuLink.hasOwnProperty('options') && !dropDownMenuLink.options.mobileMenuOnly) {
                var target = dropDownMenuLink.options ? dropDownMenuLink.options.target : null;
                return _jsx('a', {
                    className: 'm-arrow-box--link hc-cerulean c-ashen' + (i == linkArray.length - 1 ? ' last' : ''),
                    href: dropDownMenuLink.url,
                    target: target
                }, i, dropDownMenuLink.text);
            }
        }.bind(this));
        return _jsx('div', {
            style: this.props.style,
            className: 'm-arrow-box ' + (this.props.className || ''),
            id: this.props.id || 'google-dropdown-menu'
        }, void 0, dropDownMenuLinks);
    }
});
module.exports = DropDownMenu;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/drop-down-menu.jsx
 ** module id = 617
 ** module chunks = 0
 **/